import {Component, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import {ToolsService} from '../../services/tools.service';
import {ModalInterface} from '../modal-basic/ModalInterface';

@Component({
  selector: 'app-modal-errores-generico',
  templateUrl: './modal-errores-generico.component.html',
  styleUrls: ['./modal-errores-generico.component.scss']
})
export class ModalErroresGenericoComponent extends ModalInterface  implements OnInit {
  @ViewChild('dxDtgData') oDxDataGridComponent: DxDataGridComponent;
  iSelPageSize: number;
  lsPageSize: number[] = [];
  columnas: any[] = [];
  constructor(
    public tools: ToolsService,
  ) {
    super();
    this.lsPageSize = this.tools.getLimitPageSize();
    this.iSelPageSize = this.lsPageSize[1];
  }
  
  ngOnInit() {
    this.columnas = this.data.columnas;
  }
}
